import textConversion from "@/lib/prismicio/prismic-text-conversion.json"
import { PrismicTextConversionJson, textConvert } from "@jog/shared"
import { useCallback, useMemo } from "react"

export const useTextConversion = (raw: string) =>
    useMemo(() => textConvert(raw, textConversion as PrismicTextConversionJson[]), [raw])

export const useTextConversionMethod = () =>
    useCallback((raw: string) => textConvert(raw, textConversion as PrismicTextConversionJson[]), [])
